import React from "react";
import { createClient } from "@supabase/supabase-js";
import { SupabaseAuthProvider } from "@ugg/shared/components/auth/SupabaseAuthProvider";
import { SUPABASE_STORAGE_KEY } from "@ugitgud/legos/util/auth/general";

const isServer = typeof window === "undefined";

const client = createClient(process.env.UGG_PUBLIC_SUPABASE_URL, process.env.UGG_PUBLIC_SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storageKey: SUPABASE_STORAGE_KEY,
    detectSessionInUrl: false,
    autoRefreshToken: !isServer,
    persistSession: !isServer,
  },
});

export const SiteSupabaseProvider = ({ children }: { children: React.ReactNode }) => (
  <SupabaseAuthProvider client={client}>{children}</SupabaseAuthProvider>
);
